<template>
  <div class="main">
    <report-top v-if="false">
      <ly-search slot="search" v-model="searchItem.keyword" @search="search"></ly-search></report-top>
    <xtkddTop v-if="true" @now="reNow"><ly-search slot="search" v-model="searchItem.keyword"
        @search="search"></ly-search></xtkddTop>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table row-key="id" border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(220)" @on-row-click="$emit('obj', $event)"
      @on-selection-change="selectData = $event">

      <template slot-scope="{ row, index }" slot="status2">
        <Tag>{{ row.status2 }}</Tag>
        <a @click="$refs.jiedian.reach(row.no)">进程</a>
      </template>
      <div slot="bohui" slot-scope="{ row, index }">
        <Button type="text" size="small" @click="quaryBohui(row)">点开查看</Button>
      </div>
       <div slot="dsdaochu" slot-scope="{ row, index }">
        <Button type="text" size="small" @click="dsdaochu(row)">导出</Button>
      </div>
      <template slot-scope="{ row, index }" slot="tuihuo">
        <Button size="small" @click="opemTuihuo(row, index)">退货</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="again(row, index)">再来一单</Button>
        <Button size="small" @click="chuhuo(row, index)">出货总表</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button v-if="searchItem.checkStatus == 1 || searchItem.checkStatus == 3" @click="songSen"
        type="success">批量送审</Button>
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :overAuto="true" :title="isAdd ? '新增订单基本信息' : '编辑订单基本信息'" @reset="reset" :oldItem="oldItem" width="1200"
      fullscreen ref="formModel" @checkbox="reCheckbox">
      <tableForm slot="ordersGoodsList" ref="ordersGoodsList" :forms="ordersGoodsListForm" :item1="ordersGoodsListItem"
        v-model="item.ordersGoodsList" @AddressList="AddressList" :showSon="true" :tableSon="tableSon">
      </tableForm>
      <tableForm slot="ordersUnGoodsList" ref="ordersUnGoodsList" :forms="ordersUnGoodsListForms"
        :item1="ordersUnGoodsListItem" v-model="item.ordersUnGoodsList" @AddressList="AddressList" :showSon="true"
        :tableSon="tableSon">
        <Button type="error" slot="btns" size="small" @click="autoUnload">与提货信息匹配</Button>
      </tableForm>
      <tableForm slot="ordersCustomsList" ref="ordersCustomsList" :forms="ordersCustomsListForms"
        :item1="ordersCustomsListItem" v-model="item.ordersCustomsList">
      </tableForm>
      <tableForm slot="bgFilesList" ref="bgFiles" :forms="bgFilesListForms" :item1="bgFilesListItem"
        v-model="item.bgFilesList" :hideBtn="true">
      </tableForm>
      <tableForm @addItem="item.ordersChargesList[$event + 1].isAuto = false;
      item.ordersChargesList[$event + 1].id = 0;
      item.ordersChargesList[$event + 1].type = 0;" slot="ordersChargesList" ref="ordersChargesList"
        :forms="ordersChargesListForms" :item1="ordersChargesListItem" v-model="item.ordersChargesList"
        @fromInputNumber="feiyongbianhua" @fromSelect="feiyongbianhua">

        <Button type="primary" slot="btns" size="small" @click="getKesss" style="margin-left: 10px">计算费用</Button>
        <Button slot="btns" size="small" @click="reslutProcessxijie = true" v-if="reslutProcess.length > 0"
          style="margin-left: 10px">计算细节</Button>
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <form-model title="更新订单状态" width="400" ref="renwuzhuangtai">
      <Button slot="btn" type="primary" @click="updateStatus">确定更新</Button>
    </form-model>
    <form-model title="退货处理" width="500" ref="tuihuoFormModel">
      <Button slot="btn" type="primary" @click="tuihuo">确定退货</Button>
    </form-model>
    <jiedian ref="jiedian"></jiedian>
    <Modal v-model="openMuban" title="请选择报价模板" footer-hide>
      <Table @on-row-click="selectMuban" :columns="mubanCol" :data="mubans"></Table>
    </Modal>
    <formModel :title="item.no + '订单详情'" :overAuto="true" width="1200" fullscreen ref="detail">
      <tableForm slot="ordersGoodsList" ref="ordersGoodsList" :forms="ordersGoodsListForm" :item1="ordersGoodsListItem"
        v-model="item.ordersGoodsList" @AddressList="AddressList" :showSon="true" :tableSon="tableSon">
      </tableForm>
      <tableForm slot="ordersUnGoodsList" ref="ordersUnGoodsList" :forms="ordersUnGoodsListForms"
        :item1="ordersUnGoodsListItem" v-model="item.ordersUnGoodsList" @AddressList="AddressList" :showSon="true" :tableSon="tableSon">
        <Button type="error" slot="btns" size="small" @click="autoUnload">与提货信息匹配</Button>
      </tableForm>
      <tableForm slot="ordersCustomsList" ref="ordersCustomsList" :forms="ordersCustomsListForms"
        :item1="ordersCustomsListItem" v-model="item.ordersCustomsList">
      </tableForm>
      <tableForm slot="ordersChargesList" ref="ordersChargesList" :forms="ordersChargesListForms"
        :item1="ordersChargesListItem" v-model="item.ordersChargesList">
      </tableForm>
    </formModel>
    <Modal v-model="openChuhuo" fullscreen title="出货总表" footer-hide width="1000">
      <chuhuozonglan ref="chuhuo"></chuhuozonglan>
    </Modal>
    <Drawer width="500" title="计算细节" class="my-drawer" v-model="reslutProcessxijie">
      <ul>
        <li style="padding: 10px 4px" v-for="(aa, index) in reslutProcess" :key="index">
          {{ aa }}
        </li>
      </ul>
    </Drawer>
    <Modal width="400" footer-hide title="驳回理由" class="my-drawer" v-model="bohuiliyou">
      <ul>
        <li v-for="(x, index) in bohuis" :key="index" style="padding: 10px 4px">
          <h4 style="font-size: 18px;font-weight: bold;margin-bottom: 10px;">{{ x.content }}</h4>
          <ly-form-item label="驳回说明">{{ x.remark }}</ly-form-item>
          <ly-form-item label="驳回时间">{{ x.time }}</ly-form-item>
          <ly-form-item label="提交人">{{ x.creator }}</ly-form-item>

        </li>
      </ul>
    </Modal>

  </div>
</template>

<script>
var list1 = [],
  list2 = [];
var kehuitems = [], cityList = [];
var dalubaoguan = [], xianggangbaoguan = [], dagouxiangmu = [];
import tableWrap from "../../common/tableWrap.vue";
import chuhuozonglan from "./chuhuozonglan.vue";
import xtkddTop from "./xtkddTop.vue";
export default {
  components: { tableWrap, chuhuozonglan, xtkddTop },
  props: ["scan", "find"],
  data() {
    return {
      isAdd: false,
      openForm: false,
      openRelatedForm: false,
      openYundan: false,
      openMuban: false,
      openChuhuo: false,
      bohuiliyou: false,
      bohuis: [],
      columns: [

        /*  {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          type: "expand",
          width: 50,
          align: "center",
          render: (h, data) => {
            return h(tableWrap, {
              //局部注册组件不需要加引号
              props: {
                //tableList: data.row.pickupAddressList,
                tableList: [
                  {
                    columns: this.ordersGoodsListForm,
                    tableData: data.row.ordersGoodsList,
                  },
                  {
                    columns: this.ordersUnGoodsListForms,
                    tableData: data.row.ordersUnGoodsList,
                  },
                  {
                    columns: this.ordersChargesListForms,
                    tableData: data.row.ordersChargesList,
                  },
                  {
                    columns: this.ordersCustomsListForms,
                    tableData: data.row.ordersCustomsList,
                  },
                ],
              },
            });
          },
        }, */

        {
          title: "订单编号",
          minWidth: 180,
          key: "no",
          tree: true,
          sort: 0,
        },
        {
          title: "客户单号",
          minWidth: 180,
          key: "customerNo",
          sort: 2,
        }, 
        {
          title: "货物安排表",
          minWidth: 180,
          slot: "dsdaochu",
          sort: 2,
        },
        {
          title: "操作员",
          minWidth: 180,
          key: "creator",
          sort: 20,
        },
         {
          title: "创建时间",
          minWidth: 180,
          key: "createTime2",
          sort: 20,
        },
        {
          title: "订单状态",
          minWidth: 130,
          key: "status2",
          slot: "status2",
          sort: 0,
        },
        {
          title: "更多操作",
          slot: "tuihuo",
          width: 120,
          noTable: this.scan,
          align: "center",
          sort: 50,
        },
        {
          title: "操作",
          slot: "action",
          width: 200,
          noTable: this.scan,
          align: "center",
          fixed: "right",
          sort: 51,
        },
      ],
      tableData: [],
      item: {
        //xd: 0,
        id: 0,
        customs: "",
        clearanceMode: [],
        hkAgent: [],
        groupId: "",
        groupName: "",
        no: "",
        cid: "",
        customer: "",
        customerNo: "",
        carType: "",
        contractNo: "",
        addressS: "",
        addressD: "",
        bpMode: 1,
        payMode: "转账",
        deliveryMode: "派送",
        tradeType: "",
        recevieModel: "上门取货",
        sendTime: Date.now(),
        salemanId: "",
        shipmentTime: Date.now(),
        deliveryTime: Date.now(),
        saleman: "",
        isTransfers: true,
        releaseAsk: "",
        currency: "人民币",
        sealNo: "",
        cabinetNo: "",
        isTax: true,
        bgGoodsMoney: 0,
        taxRate: 0,
        exchangeRate: 1,
        remark: "",
        //extendFields: "",
        //filesPath: "",
        ordersGoodsList: [],
        ordersUnGoodsList: [],
        ordersChargesList: [],
        ordersCustomsList: [],
        bgFilesList: [],
        bgCurrency: '人民币',
        transferStore: '',
        adcodeS: '',
        adcodeD: '',
        //relatedNo:'',
        isDiscount: false,
      },

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        no: "",
        keyWork: "",
        customer: "",
        customerNo: "",
        cid: "",
        addressD: "",
        addressS: "",
        //status: 0, //订单状态(0 订单确认，1 上门提货 2 提货已完成，3-待配载,4- 已配载 5-待发车，6-已发车，7 在途中，8 已过关，9 已送达香港仓库,10 同城配送, 11未签收,12 已签收,13 客户退货)
        //bpMode: true,
        carType: "",
        tradeType: "",
        deliveryMode: "",
        checkStatuses: [],
        checkStatus: -1,//审查状态，1--未送审  2--已送审  3--被驳回
        //status:[0,1,2,3,4,5]
      },
      searchForms: [
        {
          title: "订单号",
          key: "no",
          type: "Input",
        },
        {
          title: "订单状态",
          key: "status",
          required: true,
          multiple: true,
          span: 8,
          type: "Select",
          selectItems: this.lydic["orderStatus"],
          selectType: "obj",
        },
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          span: 8,
          type: "Select",
          selectItems: kehuitems,
          selectType: "obj",
          fenlei: "基本信息",
        },
        {
          title: "贸易方式",
          key: "tradeType",
          required: false,
          type: "Select",
          selectItems: this.lydic["tradeType"],
        },
        /* {
           title: "车辆类型",
           key: "carType",
           required: false,
           type: "Select",
           selectItems: this.lydic.getA("cartype"),
         },
           {
           title: "始发地",
           key: "addressS",
           required: false,
           type: "city",
         },
         {
           title: "目的地",
           key: "addressD",
           required: false,
           type: "city",
         }, 
         {
           title: "交货方式",
           key: "deliveryMode",
           required: false,
           type: "Select",
           selectItems: ["派送", "提货", "自提", "自送", "存仓"],
         },*/
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      categorys: [],
      forms1: [
        {
          title: "订单提货",
          key: "ordersGoodsList",
          slotForm: "ordersGoodsList",
          required: true,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
      ],
      forms: [
        /* {
          title: "订单号",
          key: "no",
          required: true,
          span: 8,
          type: "Select",
          selectItems: ["TN2344224", "TN44533654"],
          fenlei: "基本信息",
        }, */
        {
          title: "客户名称",
          key: "cid",
          key2: "customer",
          required: true,
          span: 4,
          type: "Select",
          selectItems: kehuitems,
          selectType: "obj",
        },
        {
          title: "始发地",
          key: "addressS",
          adcode: "adcodeS",
          keyX: "xs",
          keyY: "ys",
          required: true,
          type: "city",
          span: 4,
        },
        {
          title: "目的地",
          key: "addressD",
          adcode: "adcodeD",
          keyX: "xd",
          keyY: "yd",
          required: true,
          type: "city",
          span: 4,
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: true,
          span: 4,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
        },
        {
          title: "车辆类型",
          key: "carType",
          required: false,
          span: 4,
          type: "selectCarType",
        },
        {
          title: "专车优惠",
          key: "isDiscount",
          type: 'bool',
          //slotForm: "relatedNo",
          noTable: true,
          span: 4,
        },
        /* {
         title: "支付方式",
         key: "payMode",
         required: true,
         span: 4,
         type: "Select",
         selectItems: ["转账", "支票", "现金"],
       },
      {
         title: "交货方式",
         key: "deliveryMode",
         required: true,
         span: 4,
         type: "Select",
         selectItems: ["派送", "提货", "自提", "自送", "存仓"],
         filterable: true,
         allowCreate: true,
       }, */
        {
          title: "贸易类型",
          key: "tradeType",
          required: true,
          span: 4,
          type: "Select",
          selectItems: this.lydic.tradeType,
        },
        /* {
          title: "收货方式",
          key: "recevieModel",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["上门取货", "自提", "自送"],
        }, */
        {
          title: "业务员",
          key4: "salemanId",
          key1: "saleman",
          keyword: "业务员",
          required: true,
          span: 4,
          type: "selectUser",
          fenlei: "基本信息",
        },
        {
          title: "中转仓库",
          key: "transferStore",
          //key2: "isTransfers2",
          required: false,
          span: 4,
          type: "Select",
          selectItems: ['大陆仓库', '香港仓库'],
        },
        {
          title: "装货时间",
          key: "shipmentTime",
          key2: "shipmentTime2",
          required: true,
          span: 6,
          width: 130,
          type: "lyyymmdd",
          formate: "datetime",
        },
        {
          title: "送货时间",
          key: "sendTime",
          key2: "sendTime2",
          required: true,
          span: 6,
          width: 130,
          type: "lyyymmdd",
          formate: "datetime",
        },
        {
          title: "交接口岸",
          key: "customs",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("port"),
          span: 4,
        },
        {
          title: "放货要求",
          key: "releaseAsk",
          required: false,
          span: 4,
          type: "Input",
          fenlei: "基本信息",
        },
        /* {
          title: "币别",
          key: "currency",
          required: false,
          span: 4,
          type: "Select",
          selectItems: this.lydic.getA("mType"),
        }, */
        {
          title: "封条号",
          key: "sealNo",
          required: false,
          span: 4,
          type: "Input",
        },
        {
          title: "柜号",
          key: "cabinetNo",
          required: false,
          type: "Input",
          span: 4,
        },
        {
          title: "是否含税",
          key: "isTax",
          key: "isTax2",
          required: false,
          span: 4,
          type: "bool",
        },
        {
          title: "税率",
          key: "taxRate",
          required: false,
          span: 4,
          type: "InputNumber",
        },
        /*  {
           title: "汇率",
           key: "exchangeRate",
           required: false,
           span: 4,
           type: "InputNumber",
         }, */

        /* {
          title: "附件路径",
          key: "filesPath",
          required: false,
          span:8,
          type: "lyPhoto",
          fenlei: "基本信息",
        }, */
        {
          title: "订单提货",
          key: "ordersGoodsList",
          slotForm: "ordersGoodsList",
          required: true,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "订单卸货",
          key: "ordersUnGoodsList",
          slotForm: "ordersUnGoodsList",
          required: false,
          noTable: true,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "报关货值",
          key: "bgGoodsMoney",
          noTable: true,
          type: "InputNumber",
          selectItems: ["电子报关", "买单", "手册", "核销单", "客人自报"],
          span: 4,
        },
        {
          title: "货值币别",
          key: 'bgCurrency',
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          //required: true,
          width: 70,
          span: 4,
        },
        {
          title: "报关方式",
          key: "clearanceMode",
          noTable: true,
          type: "checkbox",
          //selectItems: ["电子报关", "买单", "手册", "核销单", "客人自报"],
          selectItems: dalubaoguan,
          span: 24,
        },
        {
          title: "香港代理",
          key: "hkAgent",
          noTable: true,
          type: "checkbox",
          /* selectItems: [
            "无缝对接",
            "香港报关",
            "转单",
            "代缴贷垫款",
            "订舱",
            "领B/L",
            "产地证或加签",
            "做中检",
            "代理安排快递",
            "货款",
            "尾纸交",
            "仓单",
            "HK",
            "SZ",
          ], */
          selectItems: xianggangbaoguan,
          span: 24,
        },
        {
          title: "报关文件",
          key: "bgFilesList",
          slotForm: "bgFilesList",
          noTable: true,
          hideLabel: false,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },
        {
          title: "收费项目",
          key: "ordersChargesList",
          slotForm: "ordersChargesList",
          required: true,
          noTable: true,
          hideLabel: false,
          type: "Input2",
          fenlei: "基本信息",
          span: 24,
        },

        {
          title: "备注信息",
          key: "remark",
          required: false,
          span: 24,
          type: "Input",
        },
      ],
      ordersGoodsListForm: [
        {
          title: "提货名称",
          key: "name",
          required: true,
          val: "",
          type: "Input",
        },
        {
          title: "板数P/L",
          key: "pnumber",
          required: false,
          type: "InputNumber",
        },
        {
          title: "板数P/L(小)",
          key: "pnumber1",
          required: false,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "数量/件",
          key: "amount",
          required: false,
          val: 0,
          type: "InputNumber",
        },
        {
          title: "提货地址",
          key: "pickupAddress",
          slot: "pickupAddress",
          required: true,
          noUpdate: false,
          width: 300,
          type: "AddressList",
          list1: list1,
          list2: list2,
        },
        {
          title: "提货时间",
          key: "pickupTime",
          key2: "pickupTime2",
          required: false,
          type: "lyyymmdd",
        },
        {
          title: "提货方式",
          key: "recevieModel",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["上门取货", "客户自送"],
        },
        /* {
          title: "提货工厂",
          key: "pickupFactory",
          required: false,
          type: "Input",
        }, */

        /*  {
          title: "型号",
          key: "model",
          required: false,
          val: "",
          type: "Input",
        }, */

        {
          title: "联系人",
          key: "contact",
          required: false,
          val: "",
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          val: "",
          type: "Input",
        },
        /* {
          title: "条形码",
          key: "barCode",
          required: false,
          type: "Input",
        }, */
        {
          title: "备注",
          key: "remark",
          required: false,
          val: "",
          type: "Input",
        },
      ],
      ordersGoodsListItem: {
        pnumber: 1,
        pnumber1: 0,
        //id: 0,
        //pageNumber: 0,
        recevieModel: '客户自送',
        pickupTime: Date.now() + 86400000, //提货时间
        name: "",
        pickupFactory: "", //提货工厂
        barCode: "",
        pickupAddress: [], //提货地址
        contact: "",
        volume: 1,
        model: "",
        tel: "",
        amount: 1,
        weight: 1,
        //imgPath: "",
        remark: "",
        keyWork: "",
        //idList: [],
        specPart: {
          pnumber: 0,
          amount: 0,
          weight: 0,
          volume: 0,
          name: "",
        },
      },
      ordersChargesListForms: [
        {
          type: "selection",
          check: "isChoose",
          width: 70,
        },

        {
          title: "自动计算",
          key: "isAuto",
          type: "bool",
          required: true,
          width: 70,
        },
        {
          title: "收费项目",
          key: "name",
          type: "Input",
          required: true,
          width: 150,
        },
        /*  {
          title: "审核状态",
          key: "type2",
          type: "Input",
          required: true,
        }, */
        {
          title: "币别",
          key: "currencyForeign",
          type: "Select",
          selectItems: this.lydic.getA("mType"),
          required: true,
          width: 70,
        },
        {
          title: "应收金额",
          key: "receiveAmountForeign",
          type: "InputNumber",
          required: true,
          width: 70,
        },
        {
          title: "应付金额",
          key: "payAmountForeign",
          type: "InputNumber",
          required: true,
          width: 70,
        },
        {
          title: "应收(折合人民币)",
          key: "receiveAmount",
          type: "InputNumber",
          readonly: true,
          width: 70,
        },
        {
          title: "应付(折合人民币)",
          key: "payAmount",
          type: "InputNumber",
          readonly: true,
          width: 70,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          width: 300,
        },
      ],
      ordersChargesListItem: {
        isChoose: true,
        name: "",
        currencyForeign: "人民币",
        receiveAmountForeign: 0,
        payAmountForeign: 0,
        receiveAmount: 0,
        payAmount: 0,
        remark: "",
        isAuto: false
      },

      ordersUnGoodsListForms: [
        {
          title: "卸货名称",
          key: "name",
          required: true,
          type: "Input",
        },
        {
          title: "板数P/L",
          key: "pnumber",
          required: false,
          type: "InputNumber",
        },
        {
          title: "板数P/L(小)",
          key: "pnumber1",
          required: false,
          type: "InputNumber",
        },
        {
          title: "重量/kgs",
          key: "weight",
          required: false,
          type: "InputNumber",
        },
        {
          title: "体积/cbm",
          key: "volume",
          required: false,
          type: "InputNumber",
        },

        {
          title: "数量/件",
          key: "amount",
          required: false,
          type: "InputNumber",
        },
        /* {
          title: "卸货公司",
          key: "receiveCompany",
          required: false,
          type: "Input",
        }, */
        {
          title: "卸货地址",
          key: "receiveAddress",
          slot: "receiveAddress",
          required: true,
          noUpdate: false,
          width: 300,
          type: "AddressList",
          list1,
          list2,
        },
        {
          title: "交货时间",
          key: "deliveryTime",
          key2: "deliveryTime2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
        },
        {
          title: "交货方式",
          key: "deliveryMode",
          required: true,
          span: 4,
          type: "Select",
          selectItems: ["派送", "客户自提", "存仓", "直卸"],
          filterable: true,
          allowCreate: true,
        },
        {
          title: "联系人",
          key: "contact",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        /*{
          title: "单位",
          key: "unit",
          required: false,
          type: "Input",
        }, 
        {
          title: "分类",
          key: "category",
          required: true,
          type: "Input",
        },
       
        {
          title: "包装",
          key: "packing",
          required: false,
          type: "Input",
        },
        
        {
          title: "长度/cm",
          key: "length",
          required: false,
          type: "Input",
        },
        {
          title: "宽度/cm",
          key: "wide",
          required: false,
          type: "Input",
        },
        {
          title: "高度/cm",
          key: "high",
          required: false,
          type: "Input",
        },*/
        {
          title: "唛头",
          key: "mark",
          required: false,
          type: "Input",
        },

        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      ordersUnGoodsListItem: {
        deliveryTime: "",
        pnumber: 1, //大卡板
        pnumber1: 0, //小卡板
        name: "",
        volume: 0,
        weight: 0,
        mark: "",
        packing: "",
        category: "默认类别",
        deliveryMode: "派送",
        unit: "",
        receiveCompany: "",
        contact: "",
        tel: "",
        receiveAddress: [],
        length: "",
        wide: "",
        high: "",
        amount: 0,
        remark: "",
        type: 0,
        specPart: {
          pnumber: 0,
          amount: 0,
          weight: 0,
          volume: 0,
          name: "",
        },
      },

      ordersCustomsListForms: [
        /* {
          title: "订单号",
          key: "ono",
          required: false,
          type: "Select",
          selectItems: ["TN334566445", "TN3345664454"],
        }, */
        {
          title: "贸易类型",
          key: "tradeType",
          required: true,
          type: "Select",
          selectItems: ["进口", "出口"],
        },
        {
          title: "报关类型",
          key: "bgType",
          required: true,
          type: "Select",
          selectItems: ["报关", "清关", "舱单"],
        },
        {
          title: "报关方式",
          key: "mode",
          required: true,
          type: "Select",
          selectItems: ["电子报关", "客人自提", "代理报关"],
        },
        {
          title: "进出口岸",
          key: "ckPort",
          required: true,
          type: "Select",
          selectItems: this.lydic.getA("port"),
        },
        {
          title: "报关员",
          key: "bgPerson",
          required: false,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          required: false,
          type: "Input",
        },
        {
          title: "无缝号码",
          key: "wfNo",
          required: false,
          type: "Input",
        },
        {
          title: "文件数量",
          key: "filesNum",
          required: false,
          type: "InputNumber",
        },
        /* {
          title: "进口口岸",
          key: "jkPort",
          required: false,
          type: "Select",
          selectItems: this.lydic.getA("port"),
        }, */
        {
          title: "清关公司",
          key: "qgCompany",
          required: false,
          type: "Input",
        },

        {
          title: "清关号码",
          key: "qgNo",
          required: false,
          type: "Input",
        },
        {
          title: "六联单号",
          key: "sixNo",
          required: false,
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      ordersCustomsListItem: {
        tradeType: "",
        bgType: "",
        mode: "",
        ckPort: "",
        bgPerson: "",
        wfNo: "",
        tel: "",
        filesNum: 0,
        jkPort: "",
        qgCompany: "",
        qgAddress: "",
        qgNo: "",
        sixNo: "",
        remark: "",
      },
      //报关文件
      bgFilesListForms: [

        {
          title: "名称",
          key: "name",
          readonly: true,
          type: "Input",
        },
        {
          title: "文件份数",
          key: "filesNum",
          required: true,
          type: "InputNumber",
        },
        {
          title: "延展页数",
          key: "pageNum",
          required: true,
          type: "InputNumber",
        },


      ],
      bgFilesListItem: { name: "手册", filesNum: 1, pageNum: 0 },
      updateStatusItem: {
        status: 0,
      },
      updateStatusForms: [
        {
          title: "运单状态",
          key: "status",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["orderStatus"], //
          span: 24,
        },
      ],
      selectData: [],
      tuihuoItem: {
        ono: "",
        tno: "",
        storeNo: "",
        remark: "",
      },
      tuihuoForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
          readonly: true,
          required: true,
        },

        {
          title: "入仓号",
          key: "storeNo",
          required: false,
          type: "Input",
        },
        {
          title: "备注信息",
          key: "remark",
          required: false,
          type: "Input",
        },
      ],
      temItem: {
        cid: 0,
        addressS: "",
        addressD: "",
        bpMode: 0,
        carType: "",
        weight: 0,
        volume: 0,
      },
      //
      ca: {
        weight: 0,
        volume: 0,
        pnumber: 0,
      },
      mubanCol: [
        {
          title: "名称",
          key: "customer",
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
        },
        {
          title: "备注",
          key: "remark",
        },
      ],
      mubans: [],
      customerQid: "", //客户有多个报价单的时候选择
      reslutProcess: [],
      reslutProcessxijie: false,
      tableSon: [
        {
          title: "散货数量/件",
          keyp: "specPart",
          keys: "amount",
        },
        {
          title: "散货重量/kgs",
          keyp: "specPart",
          keys: "weight",
        },
        {
          title: "散货体积/cbm",
          keyp: "specPart",
          keys: "volume",
        },
      ],
      oldItem: {},
    };
  },
  methods: {

    AddressList(v, x, index) {
      //ordersGoodsList: [],
      //ordersUnGoodsList: [],
      //卸货
      if (x == "receiveAddress") {
        this.item.ordersUnGoodsList[index].tel = v[0].tel;
        this.item.ordersUnGoodsList[index].contact = v[0].contact;
      }
      //提货
      if (x == "pickupAddress") {
        this.item.ordersGoodsList[index].tel = v[0].tel;
        this.item.ordersGoodsList[index].contact = v[0].contact;
      }
    },
    //费用变化自动汇率结算
    feiyongbianhua(v, k, index) {
      //v--值 b--主键
      if (k == "receiveAmountForeign") {
        this.huiLvJiaGe(v, k, index, "receiveAmount");
      }
      if (k == "payAmountForeign") {
        this.huiLvJiaGe(v, k, index, "payAmount");
      }
      if (k == "currencyForeign") {
        var t = this.item.ordersChargesList[index].receiveAmountForeign;
        this.huiLvJiaGe(t, k, index, "receiveAmount");
        var m = this.item.ordersChargesList[index].payAmountForeign;
        this.huiLvJiaGe(m, k, index, "payAmount");
      }
    },
    //通过汇率计算，收费项目用到
    huiLvJiaGe(v, k, index, key) {
      var currency = this.item.ordersChargesList[index].currencyForeign;
      if (currency == "人民币") {
        this.item.ordersChargesList[index][key] = v;
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-base/rate/getRate",
          data: { currency: currency, cid: this.item.cid },
        }).then((res) => {
          var huilv = res.data.data.rate;
          this.item.ordersChargesList[index][key] = Number(
            (v * huilv).toFixed(2)
          );
        });
      }
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/list",

        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        console.log(data);
        this.tableData = this.chuli(data);
      });
    },
    chuli(data) {
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        data[i].sendDate2 = this.utils.time(data[i].sendDate, "yymmdd");
        data[i].isTax2 = this.$t("bool." + data[i].isTax);
        data[i].isTransfers2 = this.$t("bool." + data[i].isTransfers);
        data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
        data[i].shipmentTime2 = this.utils.time(
          data[i].shipmentTime,
          "yymmddhhmm"
        );
        var ttt =
          data[i].ordersChargesList == null ? [] : data[i].ordersChargesList;
        var type = {
          0: "未审核",
          1: "已审核",
        };
        for (let j = 0; j < ttt.length; j++) {
          ttt[j].type2 = type[ttt[j].type];
        }
        data[i].sendTime2 = this.utils.time(data[i].sendTime, "yymmddhhmm");
        data[i].createTime2 = this.utils.time(data[i].createTime, "yymmddhhmm");
        data[i].deliveryTime2 = this.utils.time(
          data[i].deliveryTime,
          "yymmddhhmm"
        );
        data[i].status2 = this.lydic.getVal("orderStatus", data[i].status);
        let fdpz = data[i].ordersFdpzList == null ? [] : data[i].ordersFdpzList;
        for (let j = 0; j < fdpz.length; j++) {
          fdpz[j].status2 = this.lydic.getVal("orderStatus", fdpz[j].status);
        }
        data[i].children =
          data[i].ordersFdpzList == null ? [] : data[i].ordersFdpzList;

        data[i]._disabled = fdpz.length > 0 ? true : false;
        data[i].pickupAddress = pick(data[i].ordersGoodsList);
        data[i].unloadAddress = unLoad(data[i].ordersUnGoodsList);
        var ordersGoodsList = data[i].ordersGoodsList;
        for (let j = 0; j < ordersGoodsList.length; j++) {
          ordersGoodsList[j].sanhuo = {
            pnumber: 123,
            amount: 456,
            weight: 0,
            volume: 0,
            name: "5645",
          };
          //deliveryTime
        }
        var ordersUnGoodsList = data[i].ordersUnGoodsList;
        for (let j = 0; j < ordersUnGoodsList.length; j++) {
          ordersUnGoodsList[j].deliveryTime2 = this.utils.time(
            ordersUnGoodsList[j].deliveryTime,
            "yymmddhhmm"
          );
          ordersUnGoodsList[j].sanhuo = {
            pnumber: 123,
            amount: 456,
            weight: 0,
            volume: 0,
            name: "5645",
          };
        }

        var t = data[i].ordersGoodsList;
        var pnumber = 0,
          amount = 0,
          weight = 0,
          volume = 0,
          name = [];
        for (let j = 0; j < t.length; j++) {
          pnumber += t[j].pnumber;
          weight += t[j].weight;
          volume += t[j].volume;
          amount += t[j].amount;
          name.push(t[j].name);
          t[j].pickupTime2 = this.utils.time(t[j].pickupTime, "yymmddhhmm");
        }
        data[i].pnumber = pnumber;
        data[i].amount = amount;
        data[i].weight = weight;
        data[i].volume = volume;
        data[i].name = name.join(",");
      }
      function pick(v) {
        var arr = [];
        for (let i = 0; i < v.length; i++) {
          var t = v[i].pickupAddress;
          for (let j = 0; j < t.length; j++) {
            arr.push(t[j]);
          }
        }

        return arr;
      }
      function unLoad(v) {
        var arr = [];

        for (let i = 0; i < v.length; i++) {
          var t = v[i].receiveAddress;
          for (let j = 0; j < t.length; j++) {
            arr.push(t[j]);
          }
        }
        return arr;
      }
      function cacu(v, type) {
        var pnumber = 0,
          amount = 0;
        for (let i = 0; i < v.length; i++) {
          pnumber += v[i].pnumber;
          amount += v[i].amount;
        }
      }
      return data;
    },
    addUpdate(name) {
      var table = this.$refs.ordersGoodsList.yanzheng();
      if (table != true) {
        this.$Message.error("订单提货：" + table);
        return;
      }
      var table = this.$refs.ordersChargesList.yanzheng();
      if (table != true) {
        this.$Message.error("收费项目：" + table);
        return;
      }
      var table = this.$refs.ordersUnGoodsList.yanzheng();
      if (table != true) {
        this.$Message.error("订单卸货：" + table);
        return;
      };

      /* var table = this.$refs.ordersCustomsList.yanzheng();
      if (table != true) {
        this.$Message.error("报关信息：" + table);
        return;
      } */
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      // this.item = a;
      var aaa = this.utils.findObj(kehuitems, "id", a.cid);
      this.item.customer = aaa.name;
      /*  var b = this.$refs.ordersGoodsList.yanzheng("货物项目");
      var c = this.$refs.ordersChargesList.yanzheng("收费项目");
      
      if (!(b && c)) {
        return;
      } */
      console.log(this.item);

      this.utils.loading(this, "提交中");
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/add",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-omc/orders/update",
          data: this.item,
        }).then((res) => {
          this.$Spin.hide(); //关闭加载
          var msg = res.data.message;
          var mmsg = this.utils.isEmpty(msg) ? [] : msg.split("_");
          if (mmsg[0] == "300") {
            alert(mmsg[1]);

          }
          if (res) {
            this.$refs.formModel.close();

            this.$emit('finishUpdata')

            this.getList();


          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-omc/orders/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    openDetail(data) {
      var m = this.chuli([data]);

      this.item = m[0];
      this.$refs.detail.reach(this.forms, this.item);
    },
    again(row) {
      this.isAdd = true;
      for (const j in this.item) {
        this.item[j] = row[j];
      }
      this.$refs.formModel.reach(this.forms, this.item);
    },
    opemUpdate(row) {
      this.isAdd = false;
      for (const j in this.item) {
        this.item[j] = row[j];
      }
      console.log(this.item);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    opemTuihuo(row) {
      this.tuihuoItem.ono = row.no;
      //this.item = JSON.parse(JSON.stringify(row));
      this.$refs.tuihuoFormModel.reach(this.tuihuoForms, this.tuihuoItem);
    },
    tuihuo(name) {
      var a = this.$refs.tuihuoFormModel.getItem();
      if (!a) {
        return;
      }
      this.tuihuoItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/back/add",
        data: this.tuihuoItem,
      }).then((res) => {
        if (res) {
          this.$refs.tuihuoFormModel.close();
          this.$Message.success("退货成功");
        }
      });
    },
    openAdd() {
      this.isAdd = true;
      this.item.carType = '';//清除车型，避免计算价格出错
      this.getBasePay();
      this.$refs.formModel.reach(this.forms, this.item);
      this.$refs.formModel.resetForm();
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //计算价格
    caculate() {
      var canshu = this.item;
      //alert(canshu.customerQid)
      /* {
        cid: this.item.cid,
        customerQid: this.customerQid,
        addressS: this.item.addressS,
        addressD: this.item.addressD,
        bpMode: this.item.bpMode,
        carType: this.item.carType,
        tradeType: this.item.tradeType,
        deliveryMode: this.item.deliveryMode,
        recevieModel: this.item.recevieModel,
        ordersGoodsList: this.item.ordersGoodsList,
        ordersUnGoodsList: this.item.ordersUnGoodsList,
        bgFilesList: this.item.bgFilesList,
        bgGoodsMoney: this.item.bgGoodsMoney
      } */;

      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-smm/customerQuotation/listCostItemMatch",
        data: canshu,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data;
        this.reslutProcess = data.reslutProcess; //计算细节

        var t = this.item.ordersChargesList;
        //清空自动保留手动
        var arr = [];
        for (let i = 0; i < t.length; i++) {
          if (t[i].isAuto == false) {
            arr.push(t[i])
          }
        }

        //this.item.ordersChargesList=arr;
        this.item.ordersChargesList = [...data.list, ...arr];
        //this.item.ordersChargesList = data.list;

      });
    },
    //获取基础费用
    getBasePay() {
      return;
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
        data: {},
      }).then((res) => {//关闭加载
        var data = res.data.data.dataList;
        this.item.ordersChargesList.length = 0;
        for (let i = 0; i < data.length; i++) {
          var obj = {
            isChoose: false,
            name: data[i].name,
            currencyForeign: "人民币",
            receiveAmountForeign: 0,
            payAmountForeign: 0,
            receiveAmount: 0,
            payAmount: 0,
            remark: "",
            isAuto: false
          }
          this.item.ordersChargesList.push(obj);
        }

      });
    },
    //查找客户的报价单
    getKesss() {
      ///cloud-tms-server-smm/customerQuotation/listByCid
      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-smm/customerQuotation/listByCid",
        data: { cid: this.item.cid },
      }).then((res) => {
        this.customerQid = "";
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.mubans = data;
        if (data.length > 1) {
          this.openMuban = true;
        } else {
          //this.getTempList();
          delete this.item.customerQid;
          this.caculate();
        }
      });
    },
    //检查费用是否符合
    getTempList() {
      var canshu = {
        cid: this.item.cid,
        customerQid: this.customerQid,
        addressS: this.item.addressS,
        addressD: this.item.addressD,
        bpMode: this.item.bpMode,
        carType: this.item.carType,
        tradeType: this.item.tradeType,
        deliveryMode: this.item.deliveryMode,
        recevieModel: this.item.recevieModel,
        ordersGoodsList: this.item.ordersGoodsList,
        ordersUnGoodsList: this.item.ordersUnGoodsList,
      };

      this.axios({
        method: "post",
        url:
          this.axios.ipPort +
          "/cloud-tms-server-smm/customerQuotation/businessTypeCheck",
        data: canshu,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res.data.data == 1) {
          //检查不通过
          alert(res.data.message);
        } else {
          //检查通过，计算价格
          this.caculate();
        }
      });
    },
    selectMuban(row) {
      this.openMuban = false;
      this.item.customerQid = row.id;
      //this.getTempList();
      this.caculate();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuliebiao() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {
          pageSize: 300,
          pageNumber: 1
        },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {


          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }

      });
    },
    openUpdateStatus(row) {
      this.updateStatusItem.status = row.status;
      this.updateStatusItem.no = row.no;

      this.$refs.renwuzhuangtai.reach(
        this.updateStatusForms,
        this.updateStatusItem
      );
    },
    updateStatus() {
      var a = this.$refs.renwuzhuangtai.getItem();
      if (!a) {
        return;
      }
      this.updateStatusItem = a;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/updateStatus",
        data: this.updateStatusItem,
      }).then((res) => {
        if (res) {
          this.$refs.renwuzhuangtai.close();
          this.getList();
        }
      });
    },
    //获取客户信息
    getKehuItem() {
      if (this.utils.isEmpty(this.item.cid)) {
        return;
      }
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/info",
        data: { id: this.item.cid },
      }).then((res) => {
        var pickupAddressList =
          res.data.data.pickupAddressList == null
            ? []
            : res.data.data.pickupAddressList;
        var shippingAddressList =
          res.data.data.shippingAddressList == null
            ? []
            : res.data.data.shippingAddressList;
        list1.splice(0, 1000);
        list2.splice(0, 1000);
        for (let i = 0; i < pickupAddressList.length; i++) {
          var add = pickupAddressList[i].address.split("_");

          var obj = {
            name: add[0],
            address: add[1],
            x: pickupAddressList[i].x,
            y: pickupAddressList[i].y,
            contact: pickupAddressList[i].contact,
            tel: pickupAddressList[i].tel,
          };
          list1.push(obj);
        }
        for (let i = 0; i < shippingAddressList.length; i++) {
          var add = shippingAddressList[i].address.split("_");
          var obj = {
            name: add[0],
            address: add[1],
            x: shippingAddressList[i].x,
            y: shippingAddressList[i].y,
            contact: shippingAddressList[i].contact,
            tel: shippingAddressList[i].tel,
          };
          list2.push(obj);
        }
      });
    },
    //获取汇率
    getRate() {

      /* this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/rate/getRate",
        data: { currency: this.item.currency, cid: this.item.cid },
      }).then((res) => {
        this.item.exchangeRate = res.data.data.rate;
      }); */
    },

    //自动完善卸货信息
    autoUnload() {
      var t = this.item.ordersGoodsList;
      var m = [];

      for (let i = 0; i < t.length; i++) {
        var e = JSON.parse(JSON.stringify(this.ordersUnGoodsListItem));
        e.pnumber = t[i].pnumber;
        e.name = t[i].name;
        e.volume = t[i].volume;
        e.weight = t[i].weight;
        e.amount = t[i].amount;
        e.specPart = t[i].specPart;
        m.push(e);
      }

      this.item.ordersUnGoodsList = m;
    },
    chuhuo(row) {
      this.openChuhuo = true;
      this.$refs.chuhuo.reach(row);
    },
    //需要听写份数的处理
    reCheckbox(key, item) {

      if (key == 'hkAgent' || key == 'clearanceMode') {
        var m = this.item.bgFilesList;
        var old = JSON.parse(JSON.stringify(m));
        console.log(old);
        m = [];

        var k = [...this.item.clearanceMode, ...this.item.hkAgent];
        //只匹配指定的类目
        //var t = ['电子报关', '买单', '手册', '香港报关', '转单'];

        var t = dagouxiangmu;
        var z = [];
        for (let i = 0; i < k.length; i++) {
          for (let j = 0; j < t.length; j++) {
            if (k[i] == t[j]) {
              z.push(t[j])
            }

          }

        }
        for (let i = 0; i < z.length; i++) {
          var obj = {
            "name": z[i],
            "filesNum": 0,
            "pageNum": 0
          }
          m.push(obj);
        }
        //匹配恢复旧数据
        for (let i = 0; i < m.length; i++) {

          for (let j = 0; j < old.length; j++) {
            if (m[i].name == old[j].name) {
              m[i].filesNum = old[j].filesNum;
              m[i].pageNum = old[j].pageNum;
            }
          }
        }
        this.item.bgFilesList = m;
        //console.log(key, item);
      }

    },
    //获取其他费用配置项目
    getOtherPay() {
      this.axios({
        method: "post",
        url:
          this.axios.ipPort + "/cloud-tms-server-omc/ordersChargesTemplet/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        dalubaoguan.length = 0;
        xianggangbaoguan.length = 0;
        dagouxiangmu.length = 0;
        //var dalubaoguan = [], xianggangbaoguan = [],dagouxiangmu=[];

        for (let i = 0; i < data.length; i++) {
          //大陆报关所有项目
          if (data[i].lable == '大陆报关') {
            dalubaoguan.push(data[i].name);
          };
          //香港报关所有项目
          if (data[i].lable == '香港报关') {
            xianggangbaoguan.push(data[i].name);
          };
          //大陆或香港打勾的项目，用于是否填写份数
          if ((data[i].lable == '大陆报关' || data[i].lable == '香港报关') && (data[i].bgCost == 1 || data[i].bgCost == 2)) {
            dagouxiangmu.push(data[i].name);
          };

        }
        //console.log('dagf', dagouxiangmu);

        //系统默认（0-否，1-是）

      });
    },
    reNow(v) {
      this.searchItem.checkStatus = v;
      var col = this.columns;
      let index = null, index1 = null;
      for (let i = 0; i < col.length; i++) {

        if (col[i].tag == 1) {
          index1 = i;
        }
        if (col[i].tag == 3) {
          index = i;
        }
      }
      if (index != null) {
        this.columns.splice(index, 1);
      }
      if (index1 != null) {
        this.columns.splice(index1, 1);
      }
      if (v == 3) {
        var obj = {
          title: '驳回理由',
          slot: 'bohui',
          tag: 3,
          sort: 0,
          width: 200
        }
        col.splice(1, 0, obj);
        //col.unshift(obj);
      }
      if (v == 1 || v == 3) {
        var obj = {
          type: "selection",
          tag: 1,
          width: 70,
          align: "center",
        };
        col.splice(0, 0, obj);
      }
      if (v == -1) {
        this.searchItem.checkStatuses = [];
      } else {
        this.searchItem.checkStatuses = [v];
      }
      this.getList();
    },
    //送审
    songSen() {
      console.log(this.selectData);
      this.utils.loading(this, "加载中");
      var t = this.selectData;
      var id = [];
      for (let i = 0; i < t.length; i++) {
        id.push(t[i].id);
      }
      console.log(id);
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/approval",
        data: { id },
      }).then((res) => {
        this.$Spin.hide();
        if (res) {
          this.getList();
        }
      });

    },
    //查询驳回理由
    quaryBohui(row) {
      this.bohuiliyou = true;
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/omcRefusalComment/list",
        data: { no: row.no },
      }).then((res) => {
        if (res) {
          console.log(res);
          var data = res.data.data.dataList;
          this.bohuis.length = 0;
          for (let i = 0; i < data.length; i++) {
            var obj = {
              content: data[i].comment,
              time: this.utils.time(data[i].createTime),
              remark: data[i].remark,
              creator: data[i].creator
            }
            this.bohuis.push(obj)
          }
        }
      });
    },
    reset(v) {
      setTimeout(() => {
        /*  this.item.ordersGoodsList=[];
         this.item.ordersUnGoodsList=[];
         this.item.ordersChargesList=[];
         this.item.ordersCustomsList=[];
         this.item.bgFilesList=[]; */
        //this.item.clearanceMode=[];
        //this.item.hkAgent=[];
        for (const i in this.item) {
          this.item[i] = this.oldItem[i]
        }

      }, 200);
      //
    },
    dsdaochu(v){
      

      var params = [
        {
          name: "customerId",
          value: v.cid,
        },
        {
          name: "no",
          value: v.no,
        },
       
      ];
      
      this.utils.exportData(
        this.axios.ipPort + "/cloud-tms-server-omc/orders/exportWord",
        params
      );
    }

  },
  mounted() {
    var config = {
      min: 100,
      max: 200,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    this.kehuliebiao();
    this.getOtherPay();
    if (this.find) {
      for (const i in this.find) {
        this.searchItem[i] = this.find[i];
      }
    }
    this.oldItem = JSON.parse(JSON.stringify(this.item))
  },
  computed: {
    cid() {
      return this.item.cid;
    },
    currency() {
      return this.item.currency;
    },
    ordersGoodsList() {
      return this.item.ordersGoodsList;
    },
    ordersGoodsListli() {
      //return this.item.ordersGoodsList.length;
    },
  },
  watch: {
    cid(v) {
      this.getKehuItem();
    },
    currency(v) {
      this.getRate();
      //var a = '440000'; //报价单
      //var b = '440102';//系统开打
      //第一步 先全部匹配 也就是440101 和a对比是否相等
      //第二步 先把b最后四位变为00 也就是440100 和a对比是否相等
      //第三步 先把b最后四位变为0000 也就是440000 和a对比是否相等
    },
    ordersGoodsList() {
      //this.item.ordersUnGoodsList.push(this.ordersUnGoodsListItem);
    },

  },
};
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/xtkd.vue